import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
    { 
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
        children: [
            // dashboard 
            {
                path: '/workbench',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/workbench.vue'),
                meta: { 
                    title: '首页',
                }
            },
           
            {
                path: '/acces',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/acces.vue'),
                meta: { 
                    title: '积分数据',
                }
            },
            {
                path: '/storeOrders',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/storeOrders.vue'),
                meta: { 
                    title: '门店订单',
                }
            },
            {
                path: '/consumerOrders',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/consumerOrders.vue'),
                meta: { 
                    title: '消费者订单',
                }
            },
            

            {
                path: '/user',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/user.vue'),
                meta: { 
                    title: '会员列表',
                }
            },
            {
                path: '/coverConfiguration',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/coverConfiguration.vue'),
                meta: { 
                    title: '封面配置',
                }
            },
            {
                path: '/activitySettings',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/activitySettings.vue'),
                meta: { 
                    title: '活动设置',
                }
            },
            {
                path: '/dynamicSettings',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/dynamicSettings.vue'),
                meta: { 
                    title: '动态设置',
                }
            },
            {
                path: '/rotatingPoster',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/rotatingPoster.vue'),
                meta: { 
                    title: '轮播海报',
                }
            },
            {
                path: '/productList',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/productList.vue'),
                meta: { 
                    title: '门店订单',
                }
            },
            {
                path: '/classificationManagement',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/dashboard/classificationManagement.vue'),
                meta: { 
                    title: '分类管理',
                }
            },
            // order

            {
                path: '/order',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/order/index.vue'),
                meta: { title: '公司信息' }
            },
            {
                path: '/aftersalesorder',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/order/aftersalesorder.vue'),
                meta: { title: '产品管理' }
            },
            {
                path: '/productevaluation',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/order/productevaluation.vue'),
                meta: { title: '二维码申请记录' }
            },

            // product
            {
                path: '/product',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/product/index.vue'),
                meta: { title: '入库明细' }
            },
            {
                path: '/productinoutbound',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/product/productinoutbound.vue'),
                meta: { title: '出库明细' }
            }, 
            // coupons
            {
                path: '/coupons',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/coupons/index.vue'),
                meta: { title: '代理商管理' }
            },
            {
                path: '/fulldeliveryactivity',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/coupons/fulldeliveryactivity.vue'),
                meta: { title: '代理商库存' }
            },
            {
                path: '/store',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/coupons/store.vue'),
                meta: { title: '门店管理' }
            },
            {
                path: '/warehousing',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/coupons/warehousing.vue'),
                meta: { title: '门店入库' }
            },
            {
                path: '/pda',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/pda/index.vue'),
                meta: { title: '出库' }
            },
            {
                path: '/return',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/pda/return.vue'),
                meta: { title: '取消出库' }
            },
            // user
            {
                path: '/userList',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/user/index.vue'),
                meta: { title: '代理商窜货统计' }
            },
            {
                path: '/userlabel',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/user/userlabel.vue'),
                meta: { title: '窜货二维码明细' }
            },
           
            
            // invoice
            {
                path: '/invoice',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/invoice/index.vue'),
                meta: { title: '二维码查询' } 
            },
            // 设置
           
            {
                path: '/clientuser',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/storeconfig/clientuser.vue'),
                meta: { title: '员工管理' }
            },
            {
                path: '/wechatconfig',
                component: () => import(/* webpackChunkName: "table" */ '../components/page/storeconfig/wechatconfig.vue'),
                meta: { title: '微信配置' }
            },
           
        ]
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
        meta: { title: '登录' },
    }
    
];

//使用钩子函数对路由进行权限跳转
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes 
});
router.beforeEach((to, from, next) => { 

    const role = localStorage.getItem('token');
    if (to.path== '/index') {
        localStorage.removeItem('user');
        localStorage.removeItem('auth_info');
        localStorage.removeItem('token');
        localStorage.removeItem('pdaToken');
        localStorage.removeItem('items');
        localStorage.removeItem('role_permission_info');
        next('/login');
        return
    }
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
});
export default router;
